export const manifest = {
  screens: {
    scr_mbtpke: { name: "Home", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_b0oiv8: { name: "Política de Privacidad", route: "/politica-de-privacidad", position: {"x":160,"y":1820} },
    scr_zsfnqp: { name: "Términos y Condiciones", route: "/terminos-y-condiciones", position: {"x":1560,"y":1820} },
    scr_63e6x9: { name: "Política de Reembolsos", route: "/politica-de-reembolsos", position: {"x":2960,"y":1820} },
    scr_us44rt: { name: "Descargo de Responsabilidad", route: "/descargo-de-responsabilidad", position: {"x":4360,"y":1820} },
  },
  sections: {
    sec_7ezojw: { name: "Legal & Policies", x: 0, y: 1600, width: 5720, height: 1180 },
  },
  layers: [
    { kind: "screen", id: "scr_mbtpke" },
    { kind: "section", id: "sec_7ezojw", children: [
      { kind: "screen", id: "scr_b0oiv8" },
      { kind: "screen", id: "scr_zsfnqp" },
      { kind: "screen", id: "scr_63e6x9" },
      { kind: "screen", id: "scr_us44rt" },
    ] },
  ],
}
